import animateOnScroll from "./animateOnScroll"
import useMarquee from './useMarquee.js';

//animate elements
/*---------------
Notes
-----------------
Offset:
- .5 means half of the element is visible before triggering
- 1 means 100% of the element should be visible
- 0 would be if any part of the element is visible 
CSS animations:
- make sure that the transformX/Y is not too large otherwise it will take forever to animate in
*/
animateOnScroll([
    { selector: ".fade-in-bottom", offset: 0.25, multiple: true },
    { selector: ".ekg", offset: 0.25, multiple: true }
]);


// Example usage of useMarquee function (no external dependencies)
const el = document.querySelector('#customMarquee');
if (el) {
    useMarquee({
        element: '#customMarquee',
        perView: 6,
        speed: 50,
        direction: 'left',
        pauseOnHover: true,
        gap: 50,
        breakpoints: {
            768: {
                perView: 3
            },
            400: {
                perView: 2
            }
        }
    });
}